import { render, staticRenderFns } from "./GenArtFilterContainer.vue?vue&type=template&id=36a224f2&scoped=true"
import script from "./GenArtFilterContainer.vue?vue&type=script&lang=js"
export * from "./GenArtFilterContainer.vue?vue&type=script&lang=js"
import style0 from "./GenArtFilterContainer.vue?vue&type=style&index=0&id=36a224f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a224f2",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fgen-art-filter-container%2FGenArtFilterContainer.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports